import React from "react";
import Cookies from 'js-cookie';
import ReactDOM from "react-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import Home from './Home'

function Login() {

  return(
    <div>
      <Auth0Provider
        domain="beetrack.auth0.com"
        clientId="80tbxRHxSVHPPysk7W8cPAY1bL4x3zi7"
        redirectUri={window.location.origin}
      >
        <Home />
      </Auth0Provider>
    </div>
  );
}

export default Login;
